module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAP1JREFUeNpiYBgFpAJGItQIALECEP8E4v9AfANJTgeIRZAVv0HCr4F4Kpph2kC8A4jlgDgfSdwFavgzIL4NxWABNSg2BuILQJyLpGk6EEcBcRYQWyGJ7wfiFeje+I/GtwPi91CvwYA8EKsCMROUbw3Vp4weZiDBRjQDs4H4OhDPAOKDQPwUTX4zEL8F4gRshhECN4F4LRBXA7EWEF8F4rtA/BibN4nFIBAJxA+A2AGItyPLM5GZnEDJ5BwQ/yDGZQ+BWBCIK5DEXkPVR+FyOQuQYMdi+zlojGlDvbUOiP+gqQEloUJivGIAxO1AnIlFThGIi4HYc7QAoRwABBgAppdMQkRrRn8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/collisionicon.png
// module id = wKfE
// module chunks = 0